"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_AUTOSAVE_RUNTIME_WINDOW_KEY = exports.CHEMKIT_AUTOSAVE_CONFIG_WINDOW_KEY = void 0;
exports.CHEMKIT_AUTOSAVE_CONFIG_WINDOW_KEY = "__CHEMKIT_AUTOSAVE_CONFIG__";
exports.CHEMKIT_AUTOSAVE_RUNTIME_WINDOW_KEY = "__CHEMKIT_AUTOSAVE_RUNTIME__";
